const SET_LOGGED_USER = (state, payload) => {
  state.user = payload;
}
const SET_LOGOUT = (state) => {
  state.user = {};
}
const SET_HEADERS = (state, payload) => {
  state.headers = payload;
}
export default {
  SET_LOGGED_USER,
  SET_LOGOUT,
  SET_HEADERS
}